import { render } from "./AchievementNotification1.vue?vue&type=template&id=c9779e58"
import script from "./AchievementNotification1.vue?vue&type=script&lang=js"
export * from "./AchievementNotification1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/achievementNotifications/AchievementNotification1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9779e58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9779e58', __exports__)) {
    api.reload('c9779e58', __exports__)
  }
  
  module.hot.accept("./AchievementNotification1.vue?vue&type=template&id=c9779e58", () => {
    api.rerender('c9779e58', render)
  })

}


export default __exports__